<div class="container">
  <a
    class="download-template-button"
    mat-stroked-button
    color="accent"
    [disabled]="!downloadLink"
    [href]="downloadLink"
    rel="noopener"
  >
    Download Template
  </a>
</div>
